<template>
  <div class="vertical-stack">
    <div class="vertical-stack__container">
      <div class="vertical-stack__row vertical-stack__row--top">
        <!--<router-link to="/foo">Go to Foo</router-link>
        <router-link to="/bar">Go to Bar</router-link>
        <router-view></router-view>-->
        <!--Params: {{ route.params }}
        <br />
        Query: {{ route.query }}-->
        <SiteHeader />
        <Timeline
          class="hideable"
          v-bind:class="{ 'hideable--hidden': !general.layout.phasesTimeline }"
          v-show="general.layout.phasesTimeline"
        />

        <LayerTiles
          :layers="orderedLayers"
          v-show="general.layout.phasesTimeline"
        ></LayerTiles>
      </div>
      <div class="vertical-stack__row vertical-stack__row--bottom">
        <div class="windowsBar">
          <Window v-if="general.layout.newComment" type="newComment">
            <template v-slot:header>Nový komentář</template>
            <template v-slot:content>
              <CommentNewForm />
            </template>
          </Window>
          <Window v-if="general.layout.newPin" type="newPin">
            <template v-slot:header>
              Nový pracovní pin
            </template>
            <template v-slot:content>
              <NewPinForm />
            </template>
          </Window>
          <Window v-if="general.layout.editPin" type="editPin">
            <template v-slot:header>
              Upravit pracovní pin <strong>{{ general.editPinId }}</strong>
            </template>
            <template v-slot:content>
              <EditPinForm />
            </template>
          </Window>
        </div>
        <div
          v-bind:class="[
            'maps',
            { 'maps--layersHidden': !general.layout.sidebarLeft },
            { 'maps--commentsHidden': !general.layout.sidebarRight }
          ]"
          v-if="general.isMobile"
        >
          <div
            class="maps__col maps__col--sidebar sidebar"
            :class="{
              'sidebar--slim':
                (general.layout.sidebarLeft || general.layout.sidebarRight) &&
                !(general.layout.sidebarLeft && general.layout.sidebarRight)
            }"
          >
            <div class="sidebar__container">
              <div class="switch-wrapper sidebar__switchers">
                <ToggleSwitch layout-part="sidebarRight" has-border
                  >Texty</ToggleSwitch
                >
                <ToggleSwitch layout-part="sidebarLeft" has-border
                  >Legenda</ToggleSwitch
                >
                <button class="float-right" @click="closeSidebar()">
                  K mapě =>
                </button>
              </div>

              <div class="row sidebar__content">
                <SidebarColTexts :orderedLayers="orderedLayers" />
                <SidebarColCaption :orderedLayers="orderedLayers" />
              </div>
              <LayerPinDetail
                :pinId="general.openedLayeredPinDetailId"
                :isOpen="general.modalOpen"
                ref="layer-pin-detail"
              />
            </div>
          </div>
          <div class="maps__col maps__col--map">
            <GmLoader>
              <GmMarker :map="gmaps.map"></GmMarker>
              <GmLayer
                v-for="sl in layers.layers"
                :google="gmaps.google"
                :map="gmaps.map"
                :key="sl.id"
                :layer="sl"
              ></GmLayer>
            </GmLoader>
            <div class="windowsBar">
              <Window v-if="general.layout.newComment" type="newComment">
                <template v-slot:header>Nový komentář</template>
                <template v-slot:content>
                  <CommentNewForm />
                </template>
              </Window>
              <Window v-if="general.layout.threadDetail" type="threadDetail">
                <template v-slot:header
                  >Detail vlákna {{ general.openedThreadDetailId }}</template
                >
                <template v-slot:content>
                  <CommentDisplay />
                </template>
              </Window>
            </div>
          </div>
        </div>
        <Splitpanes
          class="default-theme"
          v-bind:class="[
            'maps',
            { 'maps--layersHidden': !general.layout.sidebarLeft },
            { 'maps--commentsHidden': !general.layout.sidebarRight }
          ]"
          v-else
          @resized="panesContainerResizeHandler($event)"
          style="height: 100%;"
        >
          <pane
            :size="sidebarSize"
            v-show="general.layout.sidebarLeft || general.layout.sidebarRight"
            style="position: relative;"
            class="maps__pane--sidebar"
          >
            <div class="sidebar__container">
              <div class="switch-wrapper sidebar__switchers">
                <ToggleSwitch layout-part="sidebarRight" has-border
                  >Texty</ToggleSwitch
                >
                <ToggleSwitch layout-part="sidebarLeft" has-border
                  >Legenda</ToggleSwitch
                >
                <button class="float-right" @click="closeSidebar()">
                  K mapě =>
                </button>
              </div>

              <Splitpanes
                class="default-theme row sidebar__content"
                ref="sidebar"
                @resized="panesSidebarContainerResizeHandler($event)"
              >
                <pane
                  :size="general.layout.sidebarLeft ? textSize : 100"
                  v-show="general.layout.sidebarRight"
                  min-size="35"
                  max-size="90"
                  style="height: 100%;"
                  ><SidebarColTexts :orderedLayers="orderedLayers"
                /></pane>
                <pane
                  :size="general.layout.sidebarRight ? 100 - textSize : 100"
                  v-show="general.layout.sidebarLeft"
                  min-size="10"
                  max-size="65"
                  style="height: 100%;"
                  ><SidebarColCaption :orderedLayers="orderedLayers"
                /></pane>
              </Splitpanes>
              <LayerPinDetail
                :pinId="general.openedLayeredPinDetailId"
                :isOpen="general.modalOpen"
                ref="layer-pin-detail"
              />
            </div>
          </pane>
          <pane class="maps__pane--map" :size="100 - sidebarSize">
            <GmLoader>
              <GmMarker :map="gmaps.map"></GmMarker>
              <GmLayer
                v-for="sl in layers.layers"
                :google="gmaps.google"
                :map="gmaps.map"
                :key="sl.id"
                :layer="sl"
              ></GmLayer>
            </GmLoader>
            <div class="windowsBar">
              <Window v-if="general.layout.newComment" type="newComment">
                <template v-slot:header>Nový komentář</template>
                <template v-slot:content>
                  <CommentNewForm />
                </template>
              </Window>
              <Window v-if="general.layout.threadDetail" type="threadDetail">
                <template v-slot:header
                  >Detail vlákna {{ general.openedThreadDetailId }}</template
                >
                <template v-slot:content>
                  <CommentDisplay />
                </template>
              </Window>
            </div>
          </pane>
        </Splitpanes>
      </div>
    </div>
  </div>
</template>

<script>
import GmLoader from '@/components/GmLoader.vue';
import GmLayer from '@/components/GmLayer.vue';
import GmMarker from '@/components/GmMarker.vue';
import LayerTiles from '@/components/LayerTiles.vue';

import SidebarColTexts from '@/components/SidebarColTexts.vue';
import SidebarColCaption from '@/components/SidebarColCaption.vue';
import LayerPinDetail from '@/components/LayerPinDetail.vue';
import Window from '@/components/Window.vue';

import CommentNewForm from '@/components/CommentNewForm.vue';
import CommentDisplay from '@/components/CommentDisplay.vue';

import NewPinForm from '@/components/NewPinForm.vue';
import EditPinForm from '@/components/EditPinForm.vue';

import SiteHeader from '@/components/SiteHeader.vue';
import Timeline from '@/components/Timeline.vue';
import ToggleSwitch from '@/components/ToggleSwitch.vue';

import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

import _ from 'lodash';

import { mapState, mapActions } from 'vuex';

var currentPhase = 1;
var parentControls = 'texts';

export default {
  //name: `App`,
  components: {
    GmLoader,
    GmLayer,
    GmMarker,
    SidebarColTexts,
    SidebarColCaption,
    LayerPinDetail,
    Window,
    CommentNewForm,
    CommentDisplay,
    NewPinForm,
    EditPinForm,
    LayerTiles,
    SiteHeader,
    Timeline,
    ToggleSwitch,
    Splitpanes,
    Pane
  },
  data() {
    return {
      currentPhase: currentPhase,
      parentControls: parentControls,
      commentDetailOpen: true,
      textSize: this.$route.query.textSize || 50,
      sidebarSize: this.$route.query.sidebarSize || 50
    };
  },
  mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResized);

    if (!this.general.isMobile) {
      if (
        (!this.general.layout.sidebarRight &&
          this.general.layout.sidebarLeft) ||
        (this.general.layout.sidebarRight && !this.general.layout.sidebarLeft)
      ) {
        const splitter = this.$refs.sidebar.container.children[1];
        if (splitter) {
          splitter.classList.add('hidden');
        }
      }
    }
  },
  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResized);
  },
  created() {
    this.$store.dispatch('layers/fetchLayersFromPhase', [this.general.phaseId]);
    this.$store.dispatch('layers/fetchLayersForIndividualPins');
    // this.$store.dispatch('layers/fetchAllLayers');
  },
  computed: {
    ...mapState(['gmaps', 'threads', 'layers', 'general', 'route']),
    ...mapActions(['layers/fetchAllLayers']),
    orderedLayers: function () {
      let filtered = _.filter(this.layers.layers, function (layer) {
        return layer.parentId === null;
      });
      let sorted = _.orderBy(filtered, ['phaseId', 'sortNum'], ['desc', 'asc']);
      return sorted;
    }
  },
  methods: {
    splitpanesReady() {},
    onResized(event) {
      if (event.target.innerWidth <= 638) {
        this.closeSidebar();
      }
    },
    panesContainerResizeHandler(event) {
      if (event.length > 1) {
        this.sidebarSize = event[0].size;
      }
    },
    panesSidebarContainerResizeHandler(event) {
      if (event.length > 0) {
        this.textSize = event[0].size;
      }
    },
    closeSidebar() {
      this.$store.dispatch('general/setLayoutOption', ['sidebarRight', false]);
      this.$store.dispatch('general/setLayoutOption', ['sidebarLeft', false]);

      if (!this.general.isMobile) {
        this.sidebarSize = 0;
      }
    }
  },
  watch: {
    'general.layout.sidebarLeft'(newValue) {
      if (!this.general.isMobile) {
        if (newValue && this.sidebarSize == 0) {
          this.sidebarSize = 50;
        }

        if (
          (!newValue && this.general.layout.sidebarRight) ||
          (newValue && !this.general.layout.sidebarRight)
        ) {
          const splitter = this.$refs.sidebar.container.children[1];
          if (splitter) {
            splitter.classList.add('hidden');
          }
        } else {
          const splitter = this.$refs.sidebar.container.children[1];
          if (splitter) {
            splitter.classList.remove('hidden');
          }
        }
      }
    },
    'general.layout.sidebarRight'(newValue) {
      if (!this.general.isMobile) {
        if (newValue && this.sidebarSize == 0) {
          this.sidebarSize = 50;
        }

        if (
          (!newValue && this.general.layout.sidebarLeft) ||
          (newValue && !this.general.layout.sidebarLeft)
        ) {
          const splitter = this.$refs.sidebar.container.children[1];
          if (splitter) {
            splitter.classList.add('hidden');
          }
        } else {
          const splitter = this.$refs.sidebar.container.children[1];
          if (splitter) {
            splitter.classList.remove('hidden');
          }
        }
      }
    },
    textSize(newValue) {
      let obj = {
        ...this.$route.query
      };

      obj.textSize = newValue;
      obj.sidebarSize = this.sidebarSize;
      this.$router.replace({ query: obj });
    },
    sidebarSize(newValue) {
      let obj = {
        ...this.$route.query
      };

      obj.sidebarSize = newValue;
      obj.textSize = this.textSize;
      this.$router.replace({ query: obj }).catch((err) => {});
    },
    $route() {
      if (this.$route.query.sidebarSize) {
        this.sidebarSize = this.$route.query.sidebarSize;
      } else {
        let obj = {
          ...this.$route.query
        };

        obj.sidebarSize = this.sidebarSize;
        obj.textSize = this.textSize;
        this.$router.replace({ query: obj }).catch((err) => {});
      }

      if (this.$route.query.textSize) {
        this.textSize = this.$route.query.textSize;
      } else {
        let obj = {
          ...this.$route.query
        };

        obj.sidebarSize = this.sidebarSize;
        obj.textSize = this.textSize;
        this.$router.replace({ query: obj }).catch((err) => {});
      }
    }
  }
};
</script>

<style scoped>
.maps__col--map {
  display: flex;
  flex-grow: 1;
}

.maps__pane--map {
  display: flex;
  flex-grow: 1;
  flex-basis: auto;
}

.maps__pane--sidebar {
  min-width: 300px;
}

.switch-wrapper {
  padding: 0.5rem;
}

.vertical-stack {
  /* give the outermost container a predefined size */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100vw;

  display: flex;
  flex-direction: column;
}

.vertical-stack__container {
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  white-space: nowrap;

  /* for Firefox */
  min-height: 0;

  height: 100%;
}

.vertical-stack__row--bottom {
  flex-grow: 1;
  display: flex;

  overflow-y: auto;
  overflow-x: hidden;

  /* for Firefox */
  min-height: 0;

  height: 100%;
}

.sidebar {
  width: 100%;
  max-width: 40rem;
}

.sidebar--slim {
  flex-basis: 1%;
  max-width: 22rem;
}

.sidebar__container {
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  white-space: nowrap;

  /* for Firefox */
  min-height: 0;

  height: 100%;
}

.sidebar__content {
  flex-grow: 1;
  display: flex;
  min-height: 0;
  height: 100%;
  flex-direction: row !important;
}

.windowsBar {
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;

  pointer-events: none;
  background: transparent;
  /*background: url('your_transparent.png');*/

  display: flex;
  align-items: flex-end;
}

.float-right {
  float: right;
}
</style>

<style>
.sidebar__content > .splitpanes__splitter {
  height: 100% !important;
  background-color: #f2f2f2 !important;
}
.sidebar__content > .splitpanes__splitter.hidden {
  display: none;
}
.maps__col--layers,
.maps__col--comments {
  min-width: 0px !important;
}
</style>
